import React from 'react';
import PropTypes from 'prop-types';
import { SelectTree } from '@tencent/spaui-business';
import { connect } from 'react-redux';
import _ from 'lodash';

const reportHubDefaultKey = 'sale-area-select';

class AreaSelect extends React.Component {
  static propTypes = {
    areaTree: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      children: PropTypes.array,
    })).isRequired,
    onChange: PropTypes.func,
  }

  state = {
    searchValue: '',
    searchValueData: undefined,
  }

  onSearch = (e, value) => {
    value = value.trim();
    const { areaRepo, reportHubKey } = this.props;
    const reportKey = reportHubKey || reportHubDefaultKey;
    const searchValueData = _.map(
      _.filter(_.values(areaRepo), (v) => v.code !== 990000 && _.includes(v.name, value)),
      (area) => {
        return {
          value: area.code,
          label: area.name,
          'data-report': `${reportKey}-parent-${area.code}`,
        };
      },
    );
    this.setState({
      searchValue: value,
      searchValueData: !value ? undefined : searchValueData,
    });
  }

  render() {
    const { areaTree, value, className, props = {}, reportHubKey } = this.props;
    const reportKey = reportHubKey || reportHubDefaultKey;
    const data = _.map(areaTree, (area) => {
      return {
        value: area.code,
        desc: area.name,
        'data-report': `${reportKey}-parent-${area.code}`,
        options: _.map(area.children, (child) => {
          return {
            value: child.code,
            desc: child.name,
            options: _.map(child.children, (c) => {
              return {
                value: c.code,
                desc: c.name,
                'data-report': `${reportKey}-${c.code}`,
              };
            }),
          };
        }),
      };
    });
    const { searchValue, searchValueData } = this.state;
    return (
      <SelectTree
        {...props}
        clearable
        data-report={reportKey}
        className={`AreaSelect ${className}`}
        value={value}
        data={data}
        canSelected={(node) => node.value > 0}
        onChange={this.props.onChange}
        searchValue={searchValue}
        searchValueData={searchValueData}
        onSearch={this.onSearch}
        clear
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    areaTree: state.areaTree,
    areaRepo: state.areaRepo,
  };
}

export default connect(mapStateToProps)(AreaSelect);
